/**
 * Servicio para el webhook externo de n8n que procesa una CIF (PDF o imagen)
 * y devuelve los datos fiscales estructurados.
 */
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CIF_API_KEY_HEADER, CIF_FILE_FIELD } from './cif.constants';
import type { ProcesarCifResponse } from './cif.types';

@Injectable({ providedIn: 'root' })
export class CifService {
  private http = inject(HttpClient);

  /** Envía un archivo (PDF/imagen) al webhook y devuelve los datos extraídos. */
  async procesarCif(file: File): Promise<ProcesarCifResponse> {
    const formData = new FormData();
    formData.append(CIF_FILE_FIELD, file, file.name);

    const headers = new HttpHeaders({ [CIF_API_KEY_HEADER]: environment.cifApiKey });

    return firstValueFrom(
      this.http.post<ProcesarCifResponse>(environment.cifEndpoint, formData, { headers }),
    );
  }
}
